import React, { useMemo } from "react";
import { Box } from "@mui/material";

import VersionPicker from "fond/map/RightBar/VersionPicker";
import { getCurrentProject } from "fond/project";
import { useAppSelector } from "fond/utils/hooks";
import { projectCanHaveVersions } from "fond/utils/project";

import { RightBarContext, RightBarExpanded } from "./RightBarProvider";
import SearchField from "./SearchField";

const RightBar: React.FC = () => {
  const project = useAppSelector((state) => getCurrentProject(state.project));
  const [expanded, setExpanded] = React.useState<RightBarExpanded>("versions");
  const context = useMemo(
    () => ({
      expanded,
      setExpanded,
    }),
    [expanded, setExpanded]
  );

  return (
    <RightBarContext.Provider value={context}>
      <Box sx={{ display: "flex", gap: 1 }}>
        {projectCanHaveVersions(project) && <VersionPicker />}
        <SearchField />
      </Box>
    </RightBarContext.Provider>
  );
};

export default RightBar;
